import { Navigate, useLocation } from "react-router-dom";
import { useUser } from "../../contexts/UserContext";
import { useData } from "../../contexts/DataContext";
import PATHS from "../../constants/Paths";

// Component to protect routes that require authentication
export const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading } = useUser();
  const location = useLocation();

  // Show loading state while checking authentication
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-lg">Loading...</div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated()) {
    // Pass the current location so user can be redirected back after login
    return <Navigate to={PATHS.LOGIN} replace state={{ from: location }} />;
  }

  return children;
};

// Component to redirect authenticated users away from auth pages
export const AuthRedirect = ({ children }) => {
  const { isAuthenticated, isLoading, user } = useUser();
  const { clients, loading: dataLoading } = useData();

  // Show loading state while checking authentication and data
  if (isLoading || dataLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-lg">Loading...</div>
      </div>
    );
  }

  // Redirect authenticated users appropriately
  if (isAuthenticated()) {
    // Check if user has completed onboarding
    const hasCompletedOnboarding =
      user?.onboardingCompleted ||
      (clients && clients.length > 0);

    if (hasCompletedOnboarding) {
      return <Navigate to={PATHS.DASHBOARD} replace />;
    } else {
      return <Navigate to={PATHS.ONBOARDING} replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
